// extracted by mini-css-extract-plugin
export var phone = "_1c-0";
export var phoneDragging = "_1c-1";